import React, { useMemo } from 'react';
import format from 'date-fns/format';
import PropTypes from 'prop-types';

import BoxWithTwoSections from 'components/BoxWithTwoSections';

import { payoutDetails as TEXT } from 'locales/en/payout';

const PayoutDetails = ({ payout }) => {
  const leftSide = useMemo(
    () => ({
      transaction_count: payout.transaction_count,
      net: payout.amountToDisplay,
      gross: payout.grossAmountToDisplay,
      estimated_arrival: format(
        new Date(payout.estimated_arrival_date),
        'd MMM'
      ),
    }),
    [payout]
  );
  const rightSide = useMemo(
    () => ({
      refund_count: payout.debited_count,
      refund_amount: payout.debitedAmountToDisplay,
      transfers: payout.adjustment_count,
      transfer_amount: payout.adjustmentAmountToDisplay,
    }),
    [payout]
  );
  return (
    <>
      <h2 className="text-javelin-gray-dark lg:text-xl text-base font-bold">
        {TEXT.detailsHeader}
      </h2>
      <BoxWithTwoSections
        textObject={TEXT}
        data={{ left: leftSide, right: rightSide }}
      />
    </>
  );
};

PayoutDetails.propTypes = {
  payout: PropTypes.shape({}),
};
PayoutDetails.defaultProps = {
  payout: {},
};

export default PayoutDetails;
